import { render, staticRenderFns } from "./PatientSidepanel.vue?vue&type=template&id=374e6884&"
import script from "./PatientSidepanel.vue?vue&type=script&lang=js&"
export * from "./PatientSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./PatientSidepanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports